import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  overline: `Developer Portal`,
  heading: `Build with Segment data`,
  description: `Enable thousands of companies to instantly activate their first-party data in your app.`,
}

const button = {
  text: `Sign up`,
  url: `/partners/integration/`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Overline tag="p" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <StyledButton
              tag="a"
              href={getAbsoluteUrl(button.url, pageConfig)}
              size="large"
              color="primary"
              variant="filled"
            >
              {button.text}
            </StyledButton>
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    row-gap: 0;
    text-align: left;
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      text-align: center;
    }
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    width: auto;
  }
`

export default Hero
